import { Modal } from 'src/ui/common/layouts/modal';
import styled from 'styled-components';

export const StyledModal = styled(Modal)`
    max-width: 873px;
`;

export const StyledTopTextsWrapper = styled.div`
    border-bottom: 1px solid ${({ theme }) => theme.colors.gs400};
`;

export const StyledText = styled.p<{ isTextWhite?: boolean }>`
    font-size: 14px;
    line-height: 130%;
    margin-bottom: 20px;
    color: ${({ theme, isTextWhite }) => (isTextWhite ? theme.colors.white : theme.colors.gs200)};
`;

export const StyledBottomTextsWrapper = styled.div`
    margin-top: 20px;
`;